export const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
};
